// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/device_token/v2/device_token.v2.proto (package no.jotta.openapi.device_token.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.device_token.v2.TokenType
 */
export var TokenType;
(function (TokenType) {
    /**
     * @generated from enum value: UNKNOWN_TOKEN_TYPE = 0;
     */
    TokenType[TokenType["UNKNOWN_TOKEN_TYPE"] = 0] = "UNKNOWN_TOKEN_TYPE";
    /**
     * @generated from enum value: FIREBASE = 1;
     */
    TokenType[TokenType["FIREBASE"] = 1] = "FIREBASE";
})(TokenType || (TokenType = {}));
// Retrieve enum metadata with: proto3.getEnumType(TokenType)
proto3.util.setEnumType(TokenType, "no.jotta.openapi.device_token.v2.TokenType", [
    { no: 0, name: "UNKNOWN_TOKEN_TYPE" },
    { no: 1, name: "FIREBASE" },
]);
/**
 * @generated from enum no.jotta.openapi.device_token.v2.Platform
 */
export var Platform;
(function (Platform) {
    /**
     * @generated from enum value: UNKNOWN_PLATFORM = 0;
     */
    Platform[Platform["UNKNOWN_PLATFORM"] = 0] = "UNKNOWN_PLATFORM";
    /**
     * @generated from enum value: ANDROID = 1;
     */
    Platform[Platform["ANDROID"] = 1] = "ANDROID";
    /**
     * @generated from enum value: IOS = 2;
     */
    Platform[Platform["IOS"] = 2] = "IOS";
    /**
     * @generated from enum value: WIN = 3;
     */
    Platform[Platform["WIN"] = 3] = "WIN";
    /**
     * @generated from enum value: MACOS = 4;
     */
    Platform[Platform["MACOS"] = 4] = "MACOS";
    /**
     * @generated from enum value: LINUX = 5;
     */
    Platform[Platform["LINUX"] = 5] = "LINUX";
})(Platform || (Platform = {}));
// Retrieve enum metadata with: proto3.getEnumType(Platform)
proto3.util.setEnumType(Platform, "no.jotta.openapi.device_token.v2.Platform", [
    { no: 0, name: "UNKNOWN_PLATFORM" },
    { no: 1, name: "ANDROID" },
    { no: 2, name: "IOS" },
    { no: 3, name: "WIN" },
    { no: 4, name: "MACOS" },
    { no: 5, name: "LINUX" },
]);
/**
 * @generated from message no.jotta.openapi.device_token.v2.PostDeviceTokenRequest
 */
export class PostDeviceTokenRequest extends Message {
    /**
     * the token key generated by the framework in question
     *
     * @generated from field: string token_key = 1;
     */
    tokenKey = "";
    /**
     * an optional reference to be used with GetDeviceTokenRequest to lookup this token
     *
     * @generated from field: optional string token_ref = 8;
     */
    tokenRef;
    /**
     * the type of framework used to generate the token key
     *
     * @generated from field: no.jotta.openapi.device_token.v2.TokenType token_type = 2;
     */
    tokenType = TokenType.UNKNOWN_TOKEN_TYPE;
    /**
     * the id of the app posting the token
     *
     * @generated from field: string app_id = 3;
     */
    appId = "";
    /**
     * the version of the app posting the token
     *
     * @generated from field: string app_version = 4;
     */
    appVersion = "";
    /**
     * the platform of the app posting the token
     *
     * @generated from field: no.jotta.openapi.device_token.v2.Platform platform = 5;
     */
    platform = Platform.UNKNOWN_PLATFORM;
    /**
     * the device type of the app posting the token
     *
     * @generated from field: no.jotta.openapi.device_token.v2.PostDeviceTokenRequest.DeviceType device_type = 6;
     */
    deviceType = PostDeviceTokenRequest_DeviceType.UNKNOWN_DEVICE_TYPE;
    /**
     * user agent of the client posting the token
     *
     * @generated from field: string user_agent = 7;
     */
    userAgent = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device_token.v2.PostDeviceTokenRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "token_ref", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 2, name: "token_type", kind: "enum", T: proto3.getEnumType(TokenType) },
        { no: 3, name: "app_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "app_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "platform", kind: "enum", T: proto3.getEnumType(Platform) },
        { no: 6, name: "device_type", kind: "enum", T: proto3.getEnumType(PostDeviceTokenRequest_DeviceType) },
        { no: 7, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PostDeviceTokenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PostDeviceTokenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PostDeviceTokenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PostDeviceTokenRequest, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.device_token.v2.PostDeviceTokenRequest.DeviceType
 */
export var PostDeviceTokenRequest_DeviceType;
(function (PostDeviceTokenRequest_DeviceType) {
    /**
     * @generated from enum value: UNKNOWN_DEVICE_TYPE = 0;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["UNKNOWN_DEVICE_TYPE"] = 0] = "UNKNOWN_DEVICE_TYPE";
    /**
     * @generated from enum value: PHONE = 1;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["PHONE"] = 1] = "PHONE";
    /**
     * @generated from enum value: TABLET = 2;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["TABLET"] = 2] = "TABLET";
    /**
     * @generated from enum value: TV = 3;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["TV"] = 3] = "TV";
    /**
     * @generated from enum value: PC = 4;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["PC"] = 4] = "PC";
    /**
     * @generated from enum value: WEB = 5;
     */
    PostDeviceTokenRequest_DeviceType[PostDeviceTokenRequest_DeviceType["WEB"] = 5] = "WEB";
})(PostDeviceTokenRequest_DeviceType || (PostDeviceTokenRequest_DeviceType = {}));
// Retrieve enum metadata with: proto3.getEnumType(PostDeviceTokenRequest_DeviceType)
proto3.util.setEnumType(PostDeviceTokenRequest_DeviceType, "no.jotta.openapi.device_token.v2.PostDeviceTokenRequest.DeviceType", [
    { no: 0, name: "UNKNOWN_DEVICE_TYPE" },
    { no: 1, name: "PHONE" },
    { no: 2, name: "TABLET" },
    { no: 3, name: "TV" },
    { no: 4, name: "PC" },
    { no: 5, name: "WEB" },
]);
/**
 * @generated from message no.jotta.openapi.device_token.v2.PostDeviceTokenResponse
 */
export class PostDeviceTokenResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device_token.v2.PostDeviceTokenResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PostDeviceTokenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PostDeviceTokenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PostDeviceTokenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PostDeviceTokenResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device_token.v2.GetDeviceTokenRequest
 */
export class GetDeviceTokenRequest extends Message {
    /**
     * @generated from field: string token_ref = 1;
     */
    tokenRef = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device_token.v2.GetDeviceTokenRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetDeviceTokenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeviceTokenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeviceTokenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeviceTokenRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device_token.v2.GetDeviceTokenResponse
 */
export class GetDeviceTokenResponse extends Message {
    /**
     * @generated from field: string token_key = 1;
     */
    tokenKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device_token.v2.GetDeviceTokenResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetDeviceTokenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeviceTokenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeviceTokenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeviceTokenResponse, a, b);
    }
}
